<div class="container">
  <div class="card notification-card">
    <div class="card-body">
      <div class="row">
        <!-- Left section: Notification details -->
        <div class="col-md-6 d-flex flex-column justify-content-between left-section">
          <div>
            <div class="mt-3 ml-2">
              <h3 class="notify-title"> <img src="/assets/images/bell.png"
                  style="width:17px; margin-right:3px;margin-bottom: 3px;" alt=""> Notifications
                <span class="notify-count" *ngIf="totalNotifications != 0"> ({{currentNotification +
                  1}}/{{totalNotifications}})</span>
              </h3>
            </div>
            <div class="mt-4 ml-2">
              <h5 class="card-title"> <img src="/assets/images/hand.png" style="margin-right: 3px;margin-bottom: 3px;"
                  alt=""> Hi {{username}}!</h5>
              <p class="card-text">
                Hope you are having a great day.
                <span *ngIf="notifications.length > 0"> Here are a few updates that seek your immediate attention.
                  Kindly look into it at the earliest. </span>
              </p>
              <p class="description mt-2" *ngIf="notifications.length == 0"> Please note that there are no notifications
                for you at this
                moment. Feel free to check back later. </p>
              <ng-container *ngIf="isLoading">
                <div class="first-section-wrapper mt-3">
                  <div class="gravatar">
                    <ngx-skeleton-loader appearance="circle" [theme]="{ width: '30px', height: '30px' }">
                    </ngx-skeleton-loader>
                  </div>
                  <div class="gravatar-title">
                    <div>
                      <ngx-skeleton-loader [theme]="{
                        width: '230px',
                        'border-radius': '0',
                        height: '15px',
                        'margin-bottom': '10px'
                      }"></ngx-skeleton-loader>
                    </div>
                    <div>
                      <ngx-skeleton-loader [theme]="{     
                        width: '230px',
                        'border-radius': '0',
                        height: '15px'
                      }"></ngx-skeleton-loader>
                    </div>
                  </div>
                </div>
                <div class="first-section-wrapper mt-3">
                  <div class="gravatar">
                    <ngx-skeleton-loader appearance="circle" [theme]="{ width: '30px', height: '30px' }">
                    </ngx-skeleton-loader>
                  </div>
                  <div class="gravatar-title">
                    <div>
                      <ngx-skeleton-loader [theme]="{
                        width: '230px',
                        'border-radius': '0',
                        height: '15px',
                        'margin-bottom': '10px'
                      }"></ngx-skeleton-loader>
                    </div>
                    <div>
                      <ngx-skeleton-loader [theme]="{     
                        width: '230px',
                        'border-radius': '0',
                        height: '15px'
                      }"></ngx-skeleton-loader>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isLoading">
                <ng-container *ngIf="notifications.length > 0">
                  <div class="booking-opportunity mt-2">
                    <span class="badge bg-danger">{{notificationObject?.count ? notificationObject?.count : 0}}</span>
                    <span class="notification-heading">{{notificationObject.title}}</span>
                  </div>
                  <p class="description mt-2">{{notificationObject.description}}</p>
                  <p class="text-muted">Today at {{notificationObject?.date | date: 'hh:mm a'}}</p>
                  <div class="d-grid gap-2 check-section mr-3 ml-2">
                    <button class="btn btn-sm btn-primary" type="button"
                      (click)="navigateToDetails(notificationObject)">Check</button>
                  </div>
                  <div class="card-footer d-flex justify-content-end">
                    <img src="/assets/images/left.png" alt="" class="arrow" style="margin-right: 8px;"
                      (click)="previous()">
                    <img src="/assets/images/right.png" alt="" class="arrow" (click)="next()">
                  </div>
                </ng-container>
              </ng-container>

            </div>
          </div>
        </div>
        <!-- Right section: Image -->
        <div class="col-md-6 d-flex align-items-center justify-content-center right-section">
          <img src="/assets/images/Illustration.png" alt="Notification Image" class="img-fluid">
          <img class="close-button close-mark" src="/assets/images/close.png" alt="" (click)="onClose()">
        </div>
      </div>
    </div>
  </div>
</div>